const discounts = [
  { type: 'Coupon Code', method: 'Apply at checkout for instant savings', icon: 'ri-coupon-line' },
  { type: 'New User Bonus', method: 'Automatic discount upon registration', icon: 'ri-gift-line' },
  { type: 'Seasonal Sale', method: 'Limited-time promotional pricing events', icon: 'ri-calendar-event-line' },
  { type: 'Shipping Promotion', method: 'Reduced or free shipping during campaigns', icon: 'ri-ship-line' },
];

export default function DiscountSection() {
  return (
    <section id="discount" className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            Save Money
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Sugargoo Coupon &amp; Discount Code Guide
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Smart ways to reduce your total costs — from coupon codes to seasonal promotions and shipping discounts.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-10">
          {discounts.map((d) => (
            <div
              key={d.type}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 text-center hover:border-primary-200 transition-all duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className={`${d.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1.5 whitespace-nowrap">{d.type}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{d.method}</p>
            </div>
          ))}
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7">
          <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-4 text-center">
            Tips to Maximize Your Savings
          </h3>
          <div className="space-y-3">
            {[
              'Always check for active coupon codes before placing your order — seasonal events often bring the best deals.',
              'New users frequently receive welcome bonuses, so sign up even if you are just browsing for now.',
              'Combine multiple items into one shipment when possible to reduce per-item shipping costs.',
              'Monitor community forums and social channels for time-limited promotional announcements.',
              'Compare shipping methods carefully — slower options often save significant amounts on larger hauls.',
            ].map((tip, i) => (
              <div key={i} className="flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 text-xs font-semibold flex-shrink-0 mt-0.5">
                  {i + 1}
                </span>
                <p className="text-sm text-foreground-600 leading-relaxed">{tip}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-7 py-3.5 rounded-md text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            Explore Latest Deals
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}